<template>
  <div class="py-10 lg:py-20" :class="model.background">
    <div class="mx-auto w-full max-w-screen-xl px-5 md:px-12">
      <div
        class="grid grid-cols-1 items-center justify-items-center gap-x-20 gap-y-10 lg:grid-cols-2 lg:justify-items-start"
      >
        <div
          class="flex flex-col items-center text-center lg:items-start lg:text-left"
          :class="[model.imagePosition === 'right' ? 'order-2 lg:order-1' : 'order-1 lg:order-2']"
        >
          <div class="mb-7 text-2xl font-bold lg:text-64">{{ model.title }}</div>
          <div class="text-lg">{{ model.subtitle }}</div>
          <div v-if="model.buttons && model.buttons.length" class="mt-6 flex space-x-6 lg:mt-9">
            <VcButton
              v-for="(item, index) in model.buttons"
              :key="index"
              size="lg"
              v-bind="getLinkAttr(item.link)"
              class="w-auto px-8"
            >
              {{ item.label }}
            </VcButton>
          </div>
        </div>
        <div
          class="aspect-video"
          :class="[model.imagePosition === 'right' ? 'order-1 lg:order-2' : 'order-2 lg:order-1']"
        >
          <img :src="model.image" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getLinkAttr } from "@/core/utilities/common";

defineProps({
  model: {
    type: Object,
    required: true,
  },

  settings: {
    type: Object,
    required: true,
  },
});
</script>
